import { jsxs, jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { useMemo } from "react";
import { twMerge, twJoin } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./LinearProgress.module.scss.js";
const progressVariants = cva([styles["linear-progressbar"], "relative flex items-center gap-2"], {
  variants: {
    variant: {
      indeterminate: [styles["progress-indeterminate"]],
      determinate: [styles["progress-determinate"]]
    },
    color: {
      inherit: ["text-inherit"],
      primary: ["text-primary"],
      success: ["text-success"],
      danger: ["text-danger"],
      warning: ["text-warning"]
    }
  },
  defaultVariants: {
    variant: "indeterminate",
    color: "primary"
  }
});
const LinearProgress = (props) => {
  const { value, showLabel, height = 4, variant = "indeterminate", color, className, ...rest } = props;
  const offset = useMemo(() => {
    let _value = Math.max(0, value);
    _value = Math.min(_value, 100);
    return _value;
  }, [value]);
  return /* @__PURE__ */ jsxs("span", { role: "progressbar", ...rest, className: twMerge(progressVariants({ variant, color, className })), children: [
    /* @__PURE__ */ jsxs(
      "span",
      {
        className: twJoin("flex relative overflow-hidden flex-1 w-full rounded-full", styles["progress-bar"]),
        style: { height },
        children: [
          /* @__PURE__ */ jsx("span", { className: styles["line-1"], style: { width: `${offset}%` } }),
          variant === "indeterminate" && /* @__PURE__ */ jsx("span", { className: styles["line-2"] })
        ]
      }
    ),
    showLabel && variant === "determinate" && /* @__PURE__ */ jsxs("span", { className: "text-[0.8rem] leading-[1] font-medium text-grayscale-500 min-w-[35px]", children: [
      offset,
      "%"
    ] })
  ] });
};
export {
  LinearProgress as default
};
//# sourceMappingURL=LinearProgress.js.map
